class EnumString extends String {
    constructor(string, enums) {
        super(string);

        this.enums = enums;
    }

    toDescription() {
        return this.enums[this];
    }
};

const modes = {
    "CASH": "Cash",
    "CARD": "Card",
    "ONLINE": "Online",
    "EWALLET": "e-Wallet"
};

const PaymentMode = {};
for(const mode in modes) {
    PaymentMode[mode] = new EnumString(mode, modes);
}

export default PaymentMode;